import { useRef } from "react";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import SinglePage from "../SinglePage/SinglePage";
import { Container } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import Topic from "../../base/Topic/Topic";
import TopicIntro from "../../base/Topic/TopicIntro";
import { Link } from "react-router-dom";
import ImpressionsContainer from "./PlaygroundCarousel/ImpressionsContainer";

export default function KidsPlayground() {
  const topicIntroRef = useRef<HTMLDivElement>(null);

  const scrollToTopicIntro = () => {
      if (topicIntroRef.current) {
          smoothScrollTo(topicIntroRef.current, 2000);
      }
  };

  return (<SinglePage
    title='Hexenwerkstatt'
    heroBanner={
        <HeroBanner 
        imageSource = {require('../../../assets/images/KidsPlayground/PW20230219_15-12-10DSC07662.png')}
        headline="HEXENWERKSTATT."
        text="Mal- & Bastelspaß für unsere kleinsten Eckenmoorhexen." 
        onNextSection={scrollToTopicIntro}
        />
    }
    topic={
        <div ref={topicIntroRef}>
            <TopicIntro
            headline="HEXENWERKSTATT."
            introductionText="Willkommen in unserer Kreativecke für kleine Hexen. Hier können unsere jüngsten Hexen ihrer Kreativität freien Lauf lassen. Ob beim Ausmalen der Maske oder Basteln einer eigenen Hexe – hier gibt es jede Menge Spaß für kleine Künstler. Ladet euch die Vorlagen herunter, druckt sie aus und holt euch eure eigene Eckenmoorhexe ins Wohnzimmer. Viel Freude beim Malen und Basteln!"
            />
        </div>
    }
    content={
        <>
            <Container>
                <ImpressionsContainer />
            </Container>
        </>
    }
    >
</SinglePage>
);
}